import React from "react";

import { CarParkIdCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function carParkId({ width, onResize }: Column.Options) {
	return base(ColumnId.CarParkId, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default carParkId;
